export default __webpack_public_path__ + "static/media/ic_home_b.7d4b1066.svg";